import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { Usuario } from "src/app/models/Usuario/Usuario";
import { AuthService } from "src/app/modules/auth";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { ModalCommunicationService } from "src/app/services/payment-modals-communication-service.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";

@Component({
	selector: "app-modals-regularizacion",
	templateUrl: "./modals-regularizacion.component.html",
	styleUrls: ["./modals-regularizacion.component.scss"],
})
export class ModalsRegularizacionComponent implements OnInit, AfterViewInit {
	@ViewChild("modalCambiarEmpresa") modalCambiarEmpresa!: TemplateRef<any>;
	@ViewChild("modalPagoPlan") modalPagoPlan!: TemplateRef<any>;

	public currentEmisorObject: Emisor;
	public emisoresSource: Emisor[];
	public loading: boolean = false;
	public planes: Plan[];
	public datosFacturacion: EmpresaFacturacion;
	public planActual: PlanUsuario;
	public rowsDatosFacturacion: EmpresaFacturacion[] = [];
	public planSeleccionado: Plan;

	public nuevaFechaCaducidad: moment.Moment;
	public fechaActual = moment();
	public certificaciones: CertificacionPrecio[];

	public user: SessionUser;
	public resumenCuenta: Resumen;

	constructor(
		private modalCommunicationService: ModalCommunicationService,
		private userService: UsuarioService,
		private pagoService: PagoUsuarioService,
		private planUsuarioService: PlanUsuarioService,
		private tokenService: TokenStorageService,
		public datosFacturacionServicce: DatosFacturacionService,
		public emisorService: EmisorService,
		private changeCompanyService: ChangeCompanyService,
		private authService: AuthService,
		public utilities: UtilitiesService,
		private localStorage: LocalStorageService,
		private ref: ChangeDetectorRef
	) {
		this.user = this.tokenService.getUser() as SessionUser;
		

	}

	ngOnInit(): void {
		this.modalCommunicationService.triggerCargarDatos$.subscribe(() => {
			this.cargarDatos();
		});
	}
	ngAfterViewInit(): void {
		this.emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if(this.emisoresSource){
			this.currentEmisorObject = this.emisoresSource.find((x) => x.emisorId == this.tokenService.getCompany());
		}
		// Pasa el TemplateRef del modal de pago de plan al servicio
		this.changeCompanyService.setModalPagoPlanTemplate(this.modalPagoPlan);
		this.changeCompanyService.setModalChangeCompanyTemplate(this.modalCambiarEmpresa);
	}

	cargarDatos() {
		let emisorId = this.tokenService.getCompany();
		this.currentEmisorObject = this.emisoresSource.find((x) => x.emisorId == emisorId);
		this.ref.detectChanges();
		this.planUsuarioService.getInitialData().subscribe((data) => {
			this.user = this.tokenService.getUser() as SessionUser;
			this.planes = data.planes;
			this.certificaciones = data.certificaciones;
			this.userService.getUser(this.user.id, emisorId).subscribe((response) => {
				this.handleUserData(response.data, emisorId);
				this.datosFacturacionServicce.getData(this.user.id, emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.some((x) => x.emisorId == this.planActual.emisorId) ? data.find((x) => x.emisorId == this.planActual.emisorId) : data[0];
				});
			}, this.handleError);
			this.loading = false;
		});
	}

	handleUserData(userData: Usuario, emisorId: string): void {
		if (this.planActual && this.planActual.emisorId != null && this.planActual.emisorId != undefined) {
			//Existe un plan
			let planTemporal = userData.planesUsuario.find((y) => y.emisorId === this.planActual.emisorId);
			if (planTemporal == null || planTemporal == undefined) {
				this.planActual = userData.planesUsuario[0];
				this.handlePlanActual(userData);
			} else {
				this.certificaciones.forEach((x) => {
					x.solicitada = false;
				});
				userData.certificacionesPendientes.forEach((x) => {
					let certTemp = this.certificaciones.find((z) => z.codigoPrincipal === x.codigoPrincipal);
					certTemp.solicitada = true;
				});
				this.handlePlanActual(userData);
			}
		} else {
			//Es posible que el IdUsuario esté dentro de los planes del usuario
			this.planActual = userData.planesUsuario[0];
			this.handlePlanActual(userData);
		}

		if (!this.user.configured && this.planActual && this.planActual.pagado && !this.planActual.activo) {
			//En realidad no se debería hacer nada y dejar todo por defecto.
			//this.handleNotPlanActual(userData, planActual);
			let resumenCuenta = new Resumen();
			resumenCuenta.pagado = this.planActual.pagado;
			resumenCuenta.idPlanUsuario = this.planActual.idPlanUsuario;
			resumenCuenta.idPlanSf = this.planActual.idPlanSf;
			resumenCuenta.formaPago = this.planActual.formaPago;
			resumenCuenta.nombrePlan = this.planActual.nombrePlan;
			//this.resumenCuenta = resumenCuenta;
			this.notifyResumen(resumenCuenta);
		}
	}

	handlePlanActual(userData: any): void {
		this.planSeleccionado = this.planes.find((x) => x.id === this.planActual.idPlanSf);
		//this.planUsuarioPagado = planActual;
		if (!this.planActual.activo) {
			//this.idContratacion = planActual.idContratacion;
			this.certificaciones.forEach((x) => {
				x.idPlanUsuario = this.planActual.idPlanUsuario;
				x.solicitada = userData.certificacionesPendientes.some((y) => y.codigoPrincipal === x.codigoPrincipal);
			});
		} else {
			setTimeout(() => {
				this.pagoService.triggerCalculations();
			}, 0);
		}
		// TODO this.nmeses = planActual.meses;
		// TODO this.resumenCuenta.formaPago = planActual.formaPago;
	}

	handleError(error): void {
		console.log(error);
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	}

	pagar() {
		this.resumenCuenta.idDatosFacturacion = this.datosFacturacion.emisorDatosId;
		this.resumenCuenta.idEmisor = this.planActual.emisorId;
		this.resumenCuenta.idUsuario = this.user.id;
		if (this.planSeleccionado.id != this.planActual.idPlanSf) {
			this.resumenCuenta.idPlanSf = this.planSeleccionado.id;
		} else {
			this.resumenCuenta.idPlanSf = this.planActual.idPlanSf;
		}
		this.certificaciones.forEach((x) => (x.idPlanUsuario = this.planActual.idPlanUsuario));
		this.resumenCuenta.certificaciones = this.certificaciones;
		this.planUsuarioService.doPayment(this.resumenCuenta).subscribe(
			(result) => {
				if (result.status == 200) {
					if (result.data.pago == "webpay") {
						var form = document.createElement("form");
						form.method = "post";
						form.target = "_blank";
						form.action = result.data.url;
						document.body.appendChild(form);

						var input = document.createElement("input");
						input.type = "hidden";
						input.name = "token_ws";
						input.value = result.data.token;
						form.appendChild(input);
						form.submit();

						//TODO: Esperar a que finalice el pago y generar factura  para enviarla a cliente
						this.emisorService.verifyTransbank(result.data.url + "?token_ws=" + result.data.token).subscribe((succcess) => {
							if (succcess) {
								Swal.fire({
									icon: "success",
									title: "Pago Ingresado",
									text: "Se ha registrado exitosamente el pago ",
								}).then((result) => {
									if (result.isConfirmed) {
										this.changeCompanyService.cerrarModalPago();
										this.authService.logout();
									}
								});
							}
						});
					}
					this.loading = false;

					Swal.fire({
						icon: "success",
						title: "Pago Ingresado",
						text: "Operación terminada. Si el pago fue realizado con éxito se verá reflejado en breves segundos",
					}).then((result) => {
						if (result.isConfirmed) {
							this.changeCompanyService.cerrarModalPago();
							this.authService.logout();
						}
					});
				}
			},
			(error) => {
				this.loading = false;
				Swal.fire({
					icon: "error",
					title: "Error al Ingresar Emisor",
					text: "No se ha podido registrar el pago" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	notifyResumen(resumen: Resumen): void {
		//this.nuevaFechaCaducidad = moment(this.planActual.fechaCaducidad).add(resumen.meses, "months");
		this.nuevaFechaCaducidad = moment(resumen.fechaTermino);
		this.resumenCuenta = resumen;
	}

	openCambiarEmpresa(showCloseButton: boolean) {
		this.changeCompanyService.cerrarModalPago();
		this.changeCompanyService.showModalSelectorEmpresa(showCloseButton);
	}

	cambiarEmpresa(fromChangeCompany: boolean) {
		this.tokenService.setCompany(this.currentEmisorObject.emisorId);
		this.tokenService.setCompanyRut(this.currentEmisorObject.rut);
		const currentSucursalId = this.tokenService.getSubsidiary();
		this.changeCompanyService.SetNewCompany(this.currentEmisorObject, currentSucursalId);
		if (this.modalPagoPlan && !fromChangeCompany) {
			this.changeCompanyService.cerrarModalPago();
		} else if (this.modalCambiarEmpresa && fromChangeCompany) {
			this.changeCompanyService.cerrarModalCambiarEmpresa();
		}
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
	}
}
